<div class="position-relative">
  <mat-icon
    class="input-leading-icon"
    [class]="{
      'input-leading-icon-large': inputSize() === InputSize.large,
      'input-leading-icon-small': inputSize() === InputSize.small,
    }"
    [hidden]="locale.toLowerCase().startsWith('fr')"
    svgIcon="dollar">
  </mat-icon>
  <input
    class="input-base"
    [class]="{
      'input-large': inputSize() === InputSize.large,
      'input-small': inputSize() === InputSize.small,
      'leading-icon-padding': !locale.toLowerCase().startsWith('fr'),
      'trailing-icon-padding': locale.toLowerCase().startsWith('fr'),
    }"
    type="text"
    [class.input-error]="error()"
    [attr.id]="controlId()"
    [value]="value()"
    [disabled]="disabled()"
    [autocomplete]="autocomplete()"
    [attr.inputMode]="'decimal'"
    [placeholder]="placeholder()"
    [maskito]="locale.toLowerCase().startsWith('fr') ? frenchCurrencyMaskitoOptions : englishCurrencyMaskitoOptions"
    (blur)="onBlur()"
    (input)="handleInput($event)" />
  <mat-icon
    class="input-trailing-icon"
    [class]="{
      'input-trailing-icon-large': inputSize() === InputSize.large,
      'input-trailing-icon-small': inputSize() === InputSize.small,
    }"
    [hidden]="!locale.toLowerCase().startsWith('fr')"
    svgIcon="dollar">
  </mat-icon>
</div>
